module.exports = __webpack_public_path__ + "img/handmade-level.bd388933.svg";